import { render, staticRenderFns } from "./CustomerIrs.vue?vue&type=template&id=1472abea"
import script from "./CustomerIrs.vue?vue&type=script&lang=js"
export * from "./CustomerIrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports